export const PlayIcon = ({ fillRect }: { fillRect: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill={fillRect}>
            <title>Play</title>
            <path
                fill-rule="evenodd"
                d="M4.5 1.5v21L21 12 4.5 1.5Z"
                clip-rule="evenodd"></path>
        </svg>
    )
}
